import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["columns", "gutter", "style", "className"];
import React, { useMemo, forwardRef } from 'react';
import { useStyles, StyleSheet, useToken } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import GridContext from './context';
var defaultStyles = StyleSheet({
  container: {}
});

/**
 * Grid is a layout helper to make managing the structure of pages easier and more consistent
 */
// eslint-disable-next-line
export var Grid = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$columns = _ref.columns,
      columnsProp = _ref$columns === void 0 ? 12 : _ref$columns,
      _ref$gutter = _ref.gutter,
      gutterProp = _ref$gutter === void 0 ? 24 : _ref$gutter,
      style = _ref.style,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var s = useStyles(defaultStyles, 'Grid');
  var token = useToken();
  var gutter = token('grid.gutter', gutterProp);
  var columns = token('grid.columns', columnsProp);
  var sy = token('grid.spacing.y');
  var margin = typeof gutter === 'number' ? -gutter / 2 : "calc(-".concat(gutter, "/2)");
  var contextValue = useMemo(function () {
    return {
      gutter: gutter,
      columns: columns
    };
  }, [gutter, columns]);
  return /*#__PURE__*/React.createElement(GridContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Box, _extends({
    flexDirection: "row",
    flexWrap: "wrap",
    sy: sy
  }, s.with('container')({
    style: style,
    className: className,
    marginLeft: margin,
    marginRight: margin
  }), props, {
    ref: ref
  })));
});
export default Grid;